import TracPage from "@services/tracpage/types/trac-page";
import { DEFAULT_SECTIONS_CONFIG } from "../constants/default-sections-config";
import { SectionIdentifier } from "@services/tracpage/types/trac-page-section-id";

export const getSectionsToRender = (pageData: TracPage) => {
  return Object.values(pageData.sectionsConfig ?? DEFAULT_SECTIONS_CONFIG)
    .sort((a, b) => a.order - b.order)
    .map((s) => ({ ...s, title: getSectionTitle(s.id) }));
};

export const getSectionTitle = (sectionId: SectionIdentifier) => {
  switch (sectionId) {
    case SectionIdentifier.EVENTS:
      return "Tour";
    case SectionIdentifier.MERCH:
      return "Merch";
    case SectionIdentifier.MUSIC:
      return "Music";
  }
};
